import { JobRating, Publish } from "../../../common/JobOrder";
import formData from "./formData";

const {
  formField: {
    createdDate,
    fillByDate,
    smis,
    vessel,
    assignee,
    onsigner,
    onsignerLeavingFrom,
    onsignerDestination,
    onsignerTravelTimestamp,
    onsignerAccomodation,
    onsignerPickupDate,
    onsignerDropoffDate,
    onsignerNotes,
    onsignerTwicTsaNum,
    onsignerDateOfBirth,
    onsignerAgentUnion,
    onsignerUnionHall,
    offsigner,
    offsignerLeavingFrom,
    offsignerDestination,
    offsignerTravelTimestamp,
    offsignerAccomodation,
    offsignerPickupDate,
    offsignerDropoffDate,
    offsignerNotes,
    checklistRoot,
    travelDocuments,
    rating,
    port,
    reliefReason,
    flightNotice,
    reliefTime,
    offsignerTwicTsaNum,
    offsignerDateOfBirth,
    covid19Testing,
    testingLocation,
    jobType,
    publish,
    note,
  },
} = formData;

const initialValues = {
  [createdDate.name]: "",
  [fillByDate.name]: "",
  [smis.name]: "",
  [vessel.name]: undefined,
  [assignee.name]: undefined,
  [onsigner.name]: undefined,
  [onsignerLeavingFrom.name]: "",
  [onsignerDestination.name]: "",
  [onsignerTravelTimestamp.name]: "",
  [onsignerAccomodation.name]: "",
  [onsignerPickupDate.name]: "",
  [onsignerDropoffDate.name]: "",
  [onsignerNotes.name]: "",
  [onsignerTwicTsaNum.name]: "",
  [onsignerDateOfBirth.name]: "",
  [onsignerAgentUnion.name]: "",
  [onsignerUnionHall.name]: "",
  [offsigner.name]: undefined,
  [offsignerLeavingFrom.name]: "",
  [offsignerDestination.name]: "",
  [offsignerTravelTimestamp.name]: "",
  [offsignerAccomodation.name]: "",
  [offsignerPickupDate.name]: "",
  [offsignerDropoffDate.name]: "",
  [offsignerNotes.name]: "",
  [checklistRoot.name]: undefined,
  [travelDocuments.name]: [],
  [rating.name]: JobRating._Master,
  [port.name]: undefined,
  [reliefReason.name]: undefined,
  [flightNotice.name]: undefined,
  [reliefTime.name]: "",
  [offsignerTwicTsaNum.name]: "",
  [offsignerDateOfBirth.name]: "",
  [covid19Testing.name]: "",
  [testingLocation.name]: "",
  [jobType.name]: "",
  [publish.name]: Publish.CREATED,
  [note.name]: "",
};

export default initialValues;
